import React from "react";
import "./roadmap.css";

const Roadmap = () => {
  const roadmapData = {
    "Q3 2025": [
      {
        title: "Multiple Files Context Support",
        description:
          "Allowing users to add multiple files to the context of the AI model for more accurate response.",
        status: "Done",
      },
      {
        title: "AI Code Apply",
        description:
          "AI Code Apply will apply the code block to the file from chat with a single click.",
        status: "In Progress",
      },
      {
        title: "Agentic Read Mode",
        description:
          "Agentic Read Mode will automatically search through file directory, read necessary files and search through the code and through the web (if required), and respond back to the user, based on the user query.",
        status: "Up Next",
      },
    ],
    "Q4 2025": [
      {
        title: "Edit Mode",
        description:
          "Edit Mode will allow users to edit code using AI directly within Google Apps Script IDE.",
        status: "Up Next",
      },
      {
        title: "MCP Servers Integrations",
        description:
          "Allowing users to connect and interact with MCP servers directly within the platform.",
        status: "Up Next",
      },
      {
        title: "Super Suggestions",
        description:
          "Super Suggestions like the Tab Tab Tab.. feature in Cursor AI.",
        status: "Up Next",
      },
      {
        title: "Agentic Write Mode",
        description:
          "Agentic Write Mode will automatically read and then create file, edit file, and delete file based on the user query.",
        status: "Up Next",
      }
    ],
    "Q1 2026": [
      {
        title: "AI Code Review",
        description:
          "AI Code Review will automatically review the code and provide feedback to the user.",
        status: "Future",
      },
    ],
  };

  return (
    <div className="roadmap_page" id="roadmap">
      <div className="roadmap_page_h1tag">Our Development Roadmap</div>
      <div className="timeline">
        {Object.entries(roadmapData).map(([quarter, items]) => (
          <div key={quarter} className="timeline-item">
            <div className="timeline-content">
              <h2>{quarter}</h2>
              <div className="cards-container">
                {items.map((item, index) => (
                  <div key={index} className="roadmap-card">
                    <div className="card-status" data-status={item.status}>
                      {item.status}
                    </div>
                    <h3>{item.title}</h3>
                    <p>{item.description}</p>
                  </div>
                ))}
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Roadmap;